module.exports = __webpack_public_path__ + "static/img/3.15b5e8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/3.png
// module id = Lwzo
// module chunks = 0